// import breakpoints from './tokens/breakpoints';
const breakpoints = {
  '2000': 601,
  x2s: 320,
  xs: 360,
  s: 768,
  m: 1024,
  l: 1280,
  xl: 1366,
  x2l: 1920
}

const fn = br => `@media (min-width: ${breakpoints[br]}px)`;

export default fn;